import { DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES, type LanguageCode } from './config';
import { getSavedLanguage } from './index';
import { parsePath } from '../routing';

const SUPPORTED_CODES = SUPPORTED_LANGUAGES.map(lang => lang.code);

export function detectBrowserLanguage(): LanguageCode | null {
  if (typeof navigator === 'undefined') return null;
  const lang = navigator.language.toLowerCase();
  const match = SUPPORTED_CODES.find(code => lang.startsWith(code));
  return match ? (match as LanguageCode) : null;
}

export function normalizeLanguage(lang: string | null | undefined): LanguageCode {
  const value = (lang || '').toLowerCase();
  const match = SUPPORTED_CODES.find(code => value.startsWith(code));
  return match ? (match as LanguageCode) : DEFAULT_LANGUAGE;
}

export function resolveInitialLanguage(pathname?: string): LanguageCode {
  const { lang } = parsePath(pathname || '/');
  if (lang) return lang;

  const saved = getSavedLanguage();
  if (saved) return saved;

  const detected = detectBrowserLanguage();
  return detected || DEFAULT_LANGUAGE;
}

export function getDefaultLanguage(): LanguageCode {
  return DEFAULT_LANGUAGE;
}
